import { useEffect } from 'react';
import { useSecureFields } from '@gr4vy/secure-fields-react';
import { CardVaultFailureData } from '@gr4vy/secure-fields-react/lib/types';
import { GravyVaultSubmitRefState, GravyVaultSubmitResponse } from '../SecurePaymentForm.types';

type SecurePaymentSubmitProps = {
  vaultSubmitRef: React.MutableRefObject<GravyVaultSubmitRefState>;
  onBeforeSubmit?: () => void;
};

export const SecurePaymentSubmit = ({ vaultSubmitRef, onBeforeSubmit }: SecurePaymentSubmitProps) => {
  const { secureFields } = useSecureFields();

  useEffect(() => {
    if (!secureFields || typeof secureFields.submit !== 'function') {
      return;
    }

    window.submitGravyVault = (
      onSubmitSuccessCallback?: () => void,
      onSubmitError?: (error: CardVaultFailureData) => void
    ) => {
      return new Promise<GravyVaultSubmitResponse>((resolve, reject) => {
        vaultSubmitRef.current = {
          onSubmitSuccessCallback,
          onSubmitError,
          resolve,
          reject,
        };

        try {
          onBeforeSubmit?.();
          secureFields?.submit();
        } catch (err) {
          reject(err);
        }
      });
    };
    return () => {
      if (window.submitGravyVault) {
        delete window.submitGravyVault;
      }
    };
  }, [secureFields, vaultSubmitRef, onBeforeSubmit]);

  return null;
};
